import React, { useState, useEffect } from 'react';
import Services from '../services/services';
import BodyContainer from '../ui/BodyContainer';
import CustomButton from '../ui/viewEventUi/CustomButton';
import GridCenterItem from './../ui/GridCenterItem';
import TextFieldComp from './../ui/TextFieldComp';
import reserveBoxStyles from '../styles/reserveBoxStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import InputAdornment from '@material-ui/core/InputAdornment';
import Select from 'react-select';
import { useHistory, useLocation } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import { isEmail } from '../regexFuncs';

import { useDispatch, useSelector } from 'react-redux';
import { updateReserveBoxForm, clearForm } from './../redux/reserveBoxSlice';
import { getUserBrowserStorage } from '../constants';
import { backArrow } from '../ui/icons';

const useStyles = makeStyles((theme) => reserveBoxStyles(theme));

function ReserveBox() {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const reserveBox = useSelector((state) => state.reserveBox);

  const eventData = location.state?.data;
  const dataFrom = location.state?.dataFrom;
  const [apiReserveCall, setApiReserveCall] = useState(false);
  const [boxDetails, setBoxDetails] = useState([]);
  const [selectedBox, setSelectedBox] = useState(null);

  const [boxPrice, setBoxPrice] = useState('');
  const [values, setValues] = useState({});

  const userDetails = JSON.parse(getUserBrowserStorage('userDetails'));

  const setBoxSelection = (selectedOption) => {
    setValues({});
    setSelectedBox(selectedOption);
    setBoxPrice(selectedOption.boxPrice);
  };

  const handleTextChange = (event) => {
    setValues({});
    dispatch(
      updateReserveBoxForm({
        name: event.target.name,
        value: event.target.value,
      })
    );
  };

  const validationFunc = () => {
    let errors = {};
    if (!reserveBox.reserveName) {
      errors.reserveName = 'Full name is required';
    }
    if (!reserveBox.emailId) {
      errors.emailId = 'Email is required';
    } else if (!isEmail(reserveBox.emailId)) {
      errors.emailId = 'Invalid email id';
    }
    if (!selectedBox) {
      errors.box = 'Box is required.';
    }
    setValues(errors);
    const errorStatus = Object.keys(errors).length === 0;
    return errorStatus;
  };

  const handleSubmit = async (event) => {
    const formValid = validationFunc();
    if (formValid) {
      setApiReserveCall(true);
      let getObj = {
        name: reserveBox.reserveName,
        email: reserveBox.emailId,
        phoneNumber: null,
        userType: 3,
        boxName: selectedBox.value, //reserveBox.value
        eventId: eventData.eventId,
        userStreamingUrlId: 1,
        userChatId: 1,
        seatId: null,
        paymentStatus: 'N', //PB reserveBox.payment
        isBoxAssign: 'Y',
        transactionStatus: boxPrice ? 'I' : 'F', //InProgress -(I) Paid events, Finished - (F) Unpaid events
        createdBy: userDetails.userId,
        promoId: 1,
        disAmount: '10', // amount to be removed from total amount -- amount calculated from discount
        // promoId: null,
        // disAmount: null,
      };

      // const strWindowFeatures =
      //   'location=yes,height=570,width=520,scrollbars=yes,status=yes';

      const toastId = toast.loading('Processing. Please wait..');
      try {
        const res = await Services.reserve_box(getObj);
        if (res.data.responseCode === 201) {
          toast.success(res.data.details, { duration: 4000, id: toastId });
          // window.open(res.data?.paymentUrl, '_blank', strWindowFeatures);
          //Payment initiated
          history.push('/');
          return;
        } else {
          setApiReserveCall(false);
          toast.error('Failed to reserve box', { duration: 4000, id: toastId });
          return;
        }
      } catch (error) {
        setApiReserveCall(false);
        toast.error('Failed to reserve box', { duration: 4000, id: toastId });
      }
    }
  };

  const getBoxDetails = async () => {
    try {
      const res = await Services.get_box_details(
        userDetails?.userId,
        eventData.eventId
      );
      const getBoxType = res.data.Boxes.reduce((accumulator, currentVal) => {
        if (
          currentVal.isSeatAssigned === 'N' &&
          currentVal.isBoxPublic === true
        ) {
          const oneBox = {
            id: currentVal.boxName,
            value: currentVal.boxName,
            label: currentVal.boxName,
            boxPrice: currentVal.boxPrice,
          };

          return [...accumulator, oneBox];
        } else {
          return [...accumulator];
        }
      }, []);
      setBoxDetails(getBoxType);
    } catch (error) {}
  };

  const handleEnter = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault();
      handleSubmit();
    }
  };

  useEffect(() => {
    getBoxDetails();
  }, []);

  useEffect(() => {
    if (dataFrom === 'UpcomingEvents') {
      const userDetails = JSON.parse(getUserBrowserStorage('userDetails'));
      const firstName = userDetails?.firstName;
      const lastName =
        userDetails?.lastName === null ? '' : userDetails.lastName;
      handleTextChange({
        target: { value: firstName + ' ' + lastName, name: 'reserveName' },
      });
      handleTextChange({
        target: { value: userDetails?.email, name: 'emailId' },
      });
    }

    return () => {
      dispatch(clearForm());
    };
  }, []);

  const handleBackButton = () => {
    history.goBack();
  };

  return (
    <BodyContainer title='Reserve Box' icon={backArrow(handleBackButton)}>
      <Grid className={classes.gridOccupy}>
        <Paper elevation={0} className={classes.root}>
          <Box display='flex' justifyContent='center' alignItems='center'>
            <Grid
              container
              direction='row'
              alignItems='center'
              justify='center'
              alignContent='center'
              component='div'
              className={classes.boxSelectCont}
            >
              <Grid
                item
                container
                xs={12}
                sm={6}
                direction='row'
                alignItems='center'
                justify='center'
                alignContent='center'
                component='div'
                className={classes.imgCont}
              >
                <img
                  src={
                    eventData?.eventLayoutUrl
                      ? Services.event_logo_URL() + eventData.eventLayoutUrl
                      : `/assets/images/layout${eventData?.eventLayoutId_id}.png`
                  }
                  alt='stadium'
                  className='stadiumImgBox'
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <form className={classes.form}>
                  <Grid container>
                    <GridCenterItem noControl={true}>
                      <TextFieldComp
                        disabled={dataFrom === 'UpcomingEvents' ? true : false}
                        name='reserveName'
                        label='Full Name *'
                        placeholder='Full Name'
                        error={!!values?.reserveName}
                        helpertext={values?.reserveName}
                        value={reserveBox.reserveName}
                        onChange={handleTextChange}
                        handleEnter={handleEnter}
                        inputStyles={classes.inputStyles}
                      />
                    </GridCenterItem>
                    <GridCenterItem noControl={true}>
                      <TextFieldComp
                        disabled={dataFrom === 'UpcomingEvents' ? true : false}
                        name='emailId'
                        placeholder='Email Id'
                        label='Email Id *'
                        error={!!values?.emailId}
                        helpertext={values?.emailId}
                        value={reserveBox.emailId}
                        onChange={handleTextChange}
                        handleEnter={handleEnter}
                        inputStyles={classes.inputStyles}
                      />
                    </GridCenterItem>
                    <GridCenterItem noControl={true}>
                      <Grid
                        container
                        direction='row'
                        alignItems='center'
                        justify='center'
                        component='div'
                        className={classes.boxSelectContSpec}
                      >
                        <Grid
                          item
                          container
                          xs={6}
                          direction='column'
                          alignItems='center'
                          justify='center'
                          component='div'
                          style={{ position: 'relative' }}
                        >
                          <Select
                            name='boxName'
                            value={selectedBox}
                            options={boxDetails}
                            placeholder='Choose Box *'
                            styles={customStyles}
                            onChange={setBoxSelection}
                          />
                          {values?.box && (
                            <div className={classes.errorCls}>{values.box}</div>
                          )}
                        </Grid>

                        <Grid item container xs={6}>
                          {/* {eventData?.boxPrice ? ( */}
                          <TextFieldComp
                            disabled={true}
                            name='phone'
                            placeholder='Box Price'
                            label='Box Price $'
                            value={boxPrice}
                            onChange={() => null}
                            alignRight={true}
                            InputProps={{
                              startAdornment: boxPrice ? (
                                <InputAdornment position='start'>
                                  $
                                </InputAdornment>
                              ) : (
                                ''
                              ),
                            }}
                            inputStyles={classes.specInputStyles}
                          />
                          {/* // ) : null} */}
                        </Grid>
                      </Grid>
                    </GridCenterItem>
                    <div className={classes.btnContainer}>
                      <CustomButton
                        btnStyle={classes.button}
                        clickHandle={apiReserveCall ? () => null : handleSubmit}
                        btnText={'Reserve'}
                      />
                    </div>
                  </Grid>
                </form>
              </Grid>
            </Grid>
          </Box>
        </Paper>
        <Toaster position='top-center'></Toaster>
      </Grid>
    </BodyContainer>
  );
}

export default ReserveBox;

const customStyles = {
  container: (state) => ({
    ...state,
    width: '100%',
  }),
  menu: (state) => ({
    ...state,
    zIndex: 2,
    marginTop: 0,
    marginBottom: 0,
  }),

  control: (base) => ({
    ...base,
    height: 40,
    width: '100%',
    flex: 1,
    borderColor: '#0000003b',
    borderWidth: 2,
    borderStyle: 'solid',
  }),

  placeholder: (state) => ({
    position: 'absolute',
    color: 'grey',
    // top: 4,
    fontSize: '1rem',
  }),
  indicatorsContainer: (state) => ({
    position: 'absolute',
    // bottom: 4,
    right: 0,
  }),
  singleValue: (state) => ({
    position: 'absolute',
    fontSize: '1rem',
    // top: 4,
  }),
};
